module.exports = __webpack_public_path__ + "static/media/t365-logo.e52a27ad.png";